"use client";
import React, { useState } from "react";
import { useRouter } from "next/navigation";
import { useSignup } from "../../../hooks/use-signup";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";

// Supabase handled inside useSignup hook.

export default function SignupPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signup = useSignup();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    signup.mutate(
      {
        email,
        password,
        full_name: fullName,
        username,
        phone_number: phone,
      },
      {
        onSuccess: () => {
          router.replace("/dashboard");
        },
        onError: (err: unknown) => {
          const message =
            typeof err === "object" && err && "message" in err
              ? (err as { message?: string }).message || "Signup failed"
              : "Signup failed";
          setError(message);
          setLoading(false);
        },
      }
    );
  }

  return (
    <div className="relative mx-auto max-w-xl min-h-screen py-28 px-4">
      <div className="rounded-xl border bg-card text-card-foreground shadow-lg backdrop-blur-sm">
        <div className="border-b px-6 py-5">
          <h1 className="text-2xl font-semibold tracking-tight">
            Create Account
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Join The Plaster Store community and manage or claim your business
            listings.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="px-6 py-7 grid gap-6">
          <div className="grid gap-2">
            <label className="text-sm font-medium">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
          </div>
          <div className="grid gap-2">
            <label className="text-sm font-medium">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          <div className="grid gap-2 md:grid-cols-2">
            <div className="grid gap-2">
              <label className="text-sm font-medium">Full Name</label>
              <Input
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Jane Doe"
              />
            </div>
            <div className="grid gap-2">
              <label className="text-sm font-medium">Username</label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="janedoe"
              />
            </div>
          </div>
          <div className="grid gap-2 md:grid-cols-2">
            <div className="grid gap-2">
              <label className="text-sm font-medium">Phone</label>
              <Input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+1 555 123 4567"
              />
            </div>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button
            type="submit"
            disabled={loading}
            className="w-full font-medium"
          >
            {loading || signup.isPending ? "Signing up..." : "Create Account"}
          </Button>
          <p className="text-xs text-muted-foreground">
            By creating an account you agree to our{" "}
            <a href="/terms" className="underline">
              Terms
            </a>{" "}
            &{" "}
            <a href="/privacy" className="underline">
              Privacy Policy
            </a>
            .
          </p>
        </form>
        <div className="border-t px-6 py-5 text-sm text-muted-foreground">
          Already have an account?{" "}
          <a className="underline" href="/signin">
            Sign in
          </a>
        </div>
      </div>
    </div>
  );
}
